const UPDATE_FOUND = '업데이트가 발견되어 새로운 버전을 설치합니다.';

export const invokeServiceWorkerUpdateFlow = (registration) => {
  registration.waiting.postMessage('SKIP_WAITING');
  alert(UPDATE_FOUND);
};

const addUpdateFoundEventListener = (registration) => {
  registration.addEventListener('updatefound', () => {
    console.log('새로운 업데이트가 발견되었습니다');

    registration.installing.addEventListener('statechange', () => {
      if (!registration.waiting) {
        return;
      }

      if (navigator.serviceWorker.controller) {
        invokeServiceWorkerUpdateFlow(registration);
      } else {
        console.log('서비스 워커 최초 초기화...');
      }
    });
  });
};

export const registerSW = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('서비스 워커 등록:', registration);

        if (registration.waiting) {
          invokeServiceWorkerUpdateFlow(registration);
        }

        addUpdateFoundEventListener(registration);
      })
      .catch((registrationError) => {
        console.log('서비스 워커 등록 실패:', registrationError);
      });
  });
};

export const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('서비스 워커 등록 취소:', registration);
      })
      .catch((error) => {
        console.log('서비스 워커 등록 취소 실패:', error.message);
      });
  }
};
